import realpressListProperty from './wishlist/property-list';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressListProperty();
} );
